import React, { useEffect, useState, useMemo } from "react";
import { db } from "../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import "./UserRefunds.css";

function UserRefunds() {
  const username = localStorage.getItem("username");

  const [refunds, setRefunds] = useState([]);
  const [loading, setLoading] = useState(true);

  // ===============================
  // FETCH USER REFUNDS
  // ===============================
  useEffect(() => {
    if (username) {
      fetchRefunds();
    } else {
      setLoading(false);
    }
  }, [username]);

  const fetchRefunds = async () => {
    try {
      const q = query(
        collection(db, "fidia"),
        where("username", "==", username)
      );

      const snapshot = await getDocs(q);

      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setRefunds(list);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching refunds:", error);
      setLoading(false);
    }
  };

  // ===============================
  // CALCULATE TOTALS
  // ===============================
  const totals = useMemo(() => {
    return refunds.reduce(
      (acc, item) => {
        acc.tsh += Number(item.refundedTsh || 0);
        acc.usdt += Number(item.refundedUsdt || 0);
        return acc;
      },
      { tsh: 0, usdt: 0 }
    );
  }, [refunds]);

  // ===============================
  // GUARDS
  // ===============================
  if (!username) {
    return (
      <div className="refund-container">
        <p>Tafadhali ingia kwanza</p>
      </div>
    );
  }

  // ===============================
  // UI
  // ===============================
  return (
    <div className="refund-container">
      <h2>Fidia Zangu</h2>

      {loading && <p>Inapakia...</p>}

      {!loading && refunds.length === 0 && (
        <p>Hujawahi kupata fidia bado.</p>
      )}

      {/* ===== TOTAL SUMMARY ===== */}
      {!loading && refunds.length > 0 && (
        <div className="refund-summary">
          <div>
            <strong>Jumla TSH:</strong>{" "}
            {totals.tsh.toLocaleString()}
          </div>
          <div>
            <strong>Jumla USDT:</strong>{" "}
            {totals.usdt.toLocaleString()}
          </div>
        </div>
      )}

      {/* ===== TABLE ===== */}
      {!loading && refunds.length > 0 && (
        <table className="refund-table">
          <thead>
            <tr>
              <th>Mechi</th>
              <th>TSH</th>
              <th>USDT</th>
              <th>Tarehe</th>
              <th>Sababu</th>
            </tr>
          </thead>
          <tbody>
            {refunds.map((item) => (
              <tr key={item.id}>
                <td>{item.match}</td>
                <td>{Number(item.refundedTsh || 0).toLocaleString()}</td>
                <td>{Number(item.refundedUsdt || 0).toLocaleString()}</td>
                <td>
                  {item.date?.seconds
                    ? new Date(
                        item.date.seconds * 1000
                      ).toLocaleString()
                    : item.date
                    ? new Date(item.date).toLocaleString()
                    : "-"}
                </td>
                <td>{item.reason}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default UserRefunds;